<template>
  <Dialog
      :title="title"
      :show="showDialog"
      @onCancel="onCancel"
      @onConfirm="onConfirm"
      class="dialog-padding-container"
      :width="width"
  >
    <el-form :model="modelData" :rules="unusualInfoRules" label-width="150px" label-position="right">
      <el-row :gutter="24">
        <el-col :span="18">
          <el-form-item
              prop="documentNumbers"
              label="单据号：">
            <el-input disabled autosize rows="1" v-model="modelData.documentNumbers" type="textarea"  />
          </el-form-item>

        </el-col>
        <el-col :span="12">
          <el-form-item
              :rules="[{ required: true, message: '必填', trigger: 'change' }]"
              prop="operationTime"
              label="发生时间：">
            <el-date-picker
                v-model="modelData.operationTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label=" " class="jy-form-select flexbox">
            <el-checkbox v-model="modelData.isShow" label="显示在轨迹" size="large" />
          </el-form-item>
        </el-col>
        <el-col :span="18">
          <el-form-item label="内容方式:" required style="width: 50%">
            <el-radio-group
                v-model="modelData.isradio"
                @change="changeRadio"
                class="radioClass"
            >
              <el-radio label="A">模板</el-radio>
              <el-radio label="B">自定义</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item
              label="客服跟踪模板:"
              required
              style="width: 50%"
              v-if="modelData.isradio == 'A'"
          >
            <el-select
                style="width: 100%"
                clearable
                v-model="modelData.modelTitle"
                placeholder="请选择"
                @visible-change="visibleChange($event, 1)"
                filterable
                @change="changeModel"
            >
              <el-option
                  v-for="(item, index) in modelList"
                  :key="index"
                  :label="item.mainTitle"
                  :value="item.mainTitle"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="标题:" required style="width: 100%">
            <el-input
                placeholder="请输入"
                v-model="modelData.title"
            />
          </el-form-item>
          <el-form-item label="内容:" required style="width: 100%">
            <el-input
                id="contId"
                ref="myInput"
                placeholder="请输入"
                type="textarea"
                v-model="modelData.content"
                @input="inputA"
                @keydown.space.native="keydowns"
            />
            <div class="letClass" v-if="ModelFileByNumber.length > 0">
              <div style="margin-right: 10px">内容可插入变量:</div>
              <el-select
                  style="width: 200pt"
                  clearable
                  v-model="paramNameA"
                  placeholder="请选择"
                  @visible-change="visibleChange($event, 1)"
                  filterable
                  @change="changeparamName"
              >
                <el-option
                    v-for="(item, index) in ModelFileByNumber"
                    :key="index"
                    :label="item.fieldNameShow + '(' + item.paramName + ')'"
                    :value="item.paramName"
                />
              </el-select>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="18">
          <el-form-item label="图片：">
            <uploadimgs
                @input="changeFileList"
                :fileNameLists="fileNameLists"
                :limit="99"
                listType="picture-card"
            ></uploadimgs>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </Dialog>
</template>

<script>
import utils from "@/assets/js/tool";
import uploadimgs from "@/components/uploadImgs/index.vue";
import { Api } from "@/assets/js/api";
import {Message as ElMessage} from "element-ui";

export default {
  name: "selectCustomers",
  components: {
    uploadimgs
  },
  props: {
    data: Array, //表单数据
    title: {
      // 标题
      type: String,
      default: "客服跟踪",
    },
    show: {
      // 是否展示弹窗
      type: Boolean,
      default: false,
    },
    width: {
      // 标题
      type: String,
      default: "1180",
    },
    documentNumbers: {
      type: Array,
      default: () => [],
    },
    documentStatus: {
      type: String,
      default: "",
    },
    pageType: {
      type: String,
      default: "",
    },
    dataList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      paramNameA: "",
      modelList: [],
      YLModel: "",
      listA: [],
      ModelFileByNumber: [],
      contIdx: 0,
      insert: 0,
      insertend: 0,
      pageUrl: "",
      OPList: [],
      showDialog: false,
      modelData: {
        "number": "",
        "content": "",
        "documentNumbers": [],
        "documentStatus": "",
        "operationTime": "",
        "isShow": false,
        "isradio": "A",
        "title": "",
        "modelTitle": "",
        "modelContent": "",
        "modelNumber": "",
        "conditionReqs": [],
        "YLModel": "",
      },
      fileNameLists: [],
      MDconditionReqs: [],
      unusualInfoRules: {
        // 如果有验证规则可以在这里定义
        operationTime: [
          { required: true, message: '必填', trigger: 'change' }
        ]
      }
    };
  },
  watch: {
    show: {
      handler(newVal) {
        this.showDialog = newVal;
        if (newVal) {
          this.resetForm();
        }
      },
      immediate: true
    },
    pageType: {
      handler(a) {
        this.pageUrl = a;
      },
      immediate: true,
    },
    dataList: {
      handler(a) {
        this.OPList = a;
      },
      immediate: true,
    },
    showDialog: {
      handler(newVal) {
        if (newVal) {
          if (this.modelData.isradio === "A") {
            this.getModelList("DF");
          }
        }
      }
    }
  },
  methods: {
    resetForm() {
      let dlist = this.dataList;
      let numberArr = [];
      if (dlist && dlist.length > 0) {
        dlist.forEach(item => {
          numberArr.push(item.number);
        });
        this.modelData.documentNumbers = numberArr.join('\n');
      } else {
        this.modelData.documentNumbers = this.documentNumbers.join('\n');
      }

      this.modelData.documentStatus = this.documentStatus;
      this.modelData.content = "";
      this.modelData.number = "";
      this.modelData.operationTime = "";
      this.modelData.title = "";
      this.modelData.modelTitle = "";
      this.modelData.modelContent = "";
      this.modelData.modelNumber = "";
      this.modelData.conditionReqs = [];
      this.modelData.YLModel = "";
      this.modelData.isShow = false;
      this.fileNameLists = [];
      this.paramNameA = "";
      this.ModelFileByNumber = [];
    },
    changeFileList(array) {
      if (utils.jyCheckObjectType(array) == "Array") {
        this.fileNameLists = array;
      }
    },
    onCancel() {
      this.showDialog = false;
      this.$emit('onCancelCustomerService');
    },
    onConfirm() {
      let arr = [];
      this.fileNameLists.forEach(item => {
        if (item.status == 'success') {
          let obj = {
            fileId: item.name,
            fileName: item.name,
            operationType: item.operationType,
          };
          arr.push(obj);
        }
      });

      this.modelData.isShow = this.modelData.isShow ? 1 : 0;
      this.modelData.conditionReqs = this.MDconditionReqs;

      let dlist = this.dataList;
      let numberArr = [];
      if (dlist && dlist.length > 0) {
        dlist.forEach(item => {
          numberArr.push(item.number);
        });
        this.modelData.documentNumbers = numberArr;
      } else {
        this.modelData.documentNumbers = this.documentNumbers;
      }

      let params = {
        ...this.modelData,
        files: arr
      };

      Api.addKfTrackRecordV3(params).then(res => {
        if (res.status === 200) {
          const data = res.data;
          if (utils.jyCheckObjectType(data) === "Object") {
            // this.$message({
            //   message: data.message,
            //   type: data.status,
            // });
            ElMessage({
              message: data.message,
              type: data.status,
            });
            this.$emit('onConfirmCustomerService', true);
          }
        }
      });
    },
    changeRadio(val) {
      this.modelData.content = "";
      this.modelData.YLModel = "";
      this.modelData.modelNumber = "";
      this.modelData.title = "";
      this.ModelFileByNumber = [];
    },
    changeModel(e) {
      this.modelData.content = "";
      this.modelData.YLModel = "";
      this.modelData.modelNumber = "";
      this.modelList.forEach((item) => {
        if (item.mainTitle == e) {
          this.modelData.content = item.cnModel;
          this.YLModel = item.cnModel;
          this.modelData.modelNumber = item.number;
          this.modelData.title = item.mainTitle;
          this.modelData.modelContent = item.cnModel;

          this.contIdx = this.modelData.content.length || 0;
          this.listA = item.cnModel.split("#");

          this.getKfTrackModelFileByNumber(this.modelData.modelNumber);
          this.getKfTrackModelConditionByNumber(this.modelData.modelNumber);
        }
      });
    },
    getModelList(p) {
      Api.getShowKfTrackModelList({
        pageUrl: this.pageUrl,
      }).then((res) => {
        this.modelList = res.data.result || [];
        // 获取登录账号信息
        let datas = window.localStorage.getItem("personalInfo") || "";
        datas = datas ? JSON.parse(datas) : "";
        // 表示第一次默认
        if (p === "DF" && this.modelList.length > 0) {
          if (this.modelList.length == 1) {
            this.modelData.title = this.modelList[0].mainTitle;
            this.changeModel(this.modelList[0].mainTitle);
          } else {
            this.modelList.forEach((item) => {
              // 柜单通知 默认 已装柜
              if (item.number === "admin_entruck_sure") {
                this.modelData.title = item.mainTitle;
                this.changeModel(item.mainTitle);
              }
            });
          }
        }
      });
    },
    getKfTrackModelFileByNumber(num) {
      Api.getKfTrackModelFileByNumber({ modelNumber: num }).then((res) => {
        let ModelFileByNumber = res.data.result || [];
        this.ModelFileByNumber = ModelFileByNumber.filter((item) => {
          return item.isShow == 1;
        });
      });
    },
    getKfTrackModelConditionByNumber(num) {
      Api.getKfTrackModelConditionByNumber({ modelNumber: num }).then((res) => {
        let list = res.data.result || [];
        let listA = [];
        list.forEach((item) => {
          let vals = [];
          this.OPList.forEach((itemA) => {
            for (var k in itemA) {
              if (k == item.relateFieldAlias) {
                if (vals.indexOf(itemA[k]) == -1) {
                  vals.push(itemA[k]);
                }
              }
            }
          });

          let obj = {
            conditonKey: item.conditonKey,
            conditonVal: vals,
          };
          listA.push(obj);
        });
        this.MDconditionReqs = listA;
      });
    },
    visibleChange(v, type) {
      if (v) {
        if (type == 1) {
          this.getModelList();
        }
      }
    },
    inputA(e) {
      // 输入处理
    },
    keydowns(e) {
      // 空格键处理
    },
    changeparamName(val) {
      if (val) {
        this.insertAtCursor(val);
      }
    },
    // 获取光标位置并插入内容
    insertAtCursor(myValue) {
      const myField = document.querySelector("#contId");
      if (myField.selectionStart || myField.selectionStart === 0) {
        var startPos = myField.selectionStart;
        var endPos = myField.selectionEnd;
        this.modelData.content =
            myField.value.substring(0, startPos) +
            "#" + myValue + "#" +
            myField.value.substring(endPos, myField.value.length);

        this.$nextTick(() => {
          myField.focus();
          // 设置光标位置
          if (myValue.indexOf("(") !== -1) {
            let arr = myValue.split("");
            let index = arr.findIndex((o) => {
              return o == "(";
            });
            myField.setSelectionRange(endPos + index + 2, endPos + index + 2);
          } else {
            myField.setSelectionRange(
                endPos + myValue.length + 2,
                endPos + myValue.length + 2
            );
          }
        });
      } else {
        this.modelData.content += "#" + myValue + "#";
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.pagination-box{
  margin-top: 16px;
}

.radioClass {
  width: 100%;
  padding: 0 10px;
  box-sizing: border-box;
  border: 1px solid #dcdfe6;
  border-radius: 3px;
  display: flex;
  flex-wrap: wrap;
}

.letClass {
  display: flex;
  align-items: center;
  margin-top: 10px;
}
</style>
